import { render, staticRenderFns } from "./TabRouteView.vue?vue&type=template&id=c59cd30c&scoped=true&"
import script from "./TabRouteView.vue?vue&type=script&lang=js&"
export * from "./TabRouteView.vue?vue&type=script&lang=js&"
import style0 from "./TabRouteView.vue?vue&type=style&index=0&id=c59cd30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../steam-app-cms-prod/steam-app-cms/sources/client/fastboot-cms-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59cd30c",
  null
  
)

export default component.exports